(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name crewViolations.controller:CrewViolationsCtrl
   *
   * @description
   *
   */
  angular
    .module('consecutiveDayFlightAndEarlyMorningDeparture')
    .controller('DayAndEarlyMorningFlightCtrl', DayAndEarlyMorningFlightCtrl);

  function DayAndEarlyMorningFlightCtrl(CommonMasterData, dayAndEarlyMorningFlightService ,MessageService, $compile,$scope,StorageServices,TabService,applicationConstants) {
    var vm = this;
    vm.ctrlName = 'DayAndEarlyMorningFlightCtrl';

    vm.model = {
      searchPanelToggle: true,
      width: window.screen.width,
      height:window.screen.height,
      searchOnGoing: false,
      totalNumberOfRecords:null,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        crewType: null,
        aircraftType: null,
        blankDaysOnly: false,
        autoOrManual : null

      },
      masterList: {
        crewTypeList: [],
        aircraftTypes: [],
        fromDateFormatInvalid: false,
        toDateFormatInvalid: false,
        fromDateAfterToDate: false,
        autoManualList : [{'autoOrManualCode':'M', 'autoOrManualDesc':'Manual'}, {'autoOrManualCode':'A', 'autoOrManualDesc':'Auto'}]

      },
      lastSearchDates:{
    	  fromDate:null,
    	  toDate:null
      },
      dayAndEarlyMorningFlightList: [],
      initialSearchDone: false
    };

    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    var dataObject = [];
    var hotSettings = [];
    var hot;

    vm.submitSearch = function (params) {
      dayAndEarlyMorningFlightService.searchDayAndEarlyMorningFlight(params,
        function (response) {
    	    vm.model.lastSearchDates.fromDate = vm.model.searchCriteria.fromDate;
    	    vm.model.lastSearchDates.toDate = vm.model.searchCriteria.toDate;
          vm.model.dayAndEarlyMorningFlightList = response.dayAndEarlyMorningFlightResponseDTOS;
          vm.model.searchPanelToggle = false;
          vm.model.totalNumberOfRecords = response.dayAndEarlyMorningFlightResponseDTOS.length;
          dataObject = vm.dataObject();
          hotSettings = vm.hotSettings();
          hot = new Handsontable(hotElement, hotSettings);
          $compile(hotElement)($scope);
          console.log("vm.model.dayAndEarlyMorningFlightList",vm.model.dayAndEarlyMorningFlightList);
        },
        function (error) {
          MessageService.error(error[0]);
        }
      );
    };

    vm.dataObject = function () {
      var dataObject = [];

      for (var i in vm.model.dayAndEarlyMorningFlightList) {
        dataObject.push({
          ROW_NUMBER : parseInt(i)+1,
          CREW_TYPE_CODE : vm.model.dayAndEarlyMorningFlightList[i].crewType,
          CREW_ID: vm.model.dayAndEarlyMorningFlightList[i].crewID,
          FIRST_NAME: vm.model.dayAndEarlyMorningFlightList[i].crewFirstName,
          LAST_NAME: vm.model.dayAndEarlyMorningFlightList[i].crewLastName,
          FLIGHT_NUMBER: vm.model.dayAndEarlyMorningFlightList[i].flightNumber,
          ORIGIN: vm.model.dayAndEarlyMorningFlightList[i].origin,
          DESTINATION: vm.model.dayAndEarlyMorningFlightList[i].destination,
          DEPARTURE_DATE_TIME: removeSeconds(vm.model.dayAndEarlyMorningFlightList[i].departureDateTime),
          ARRIVAL_DATE_TIME: removeSeconds(vm.model.dayAndEarlyMorningFlightList[i].arrivalDateTime),
          DEPARTURE_DATE_TIME_LOCAL: removeSeconds(vm.model.dayAndEarlyMorningFlightList[i].departureDateTimeLocal),
          ARRIVAL_DATE_TIME_LOCAL: removeSeconds(vm.model.dayAndEarlyMorningFlightList[i].arrivalDateTimeLocal),
          PREV_DAY_FLIGHT_NUMBER: vm.model.dayAndEarlyMorningFlightList[i].prevDayFlightNumber,
          PREV_DAY_ORIGIN: vm.model.dayAndEarlyMorningFlightList[i].prevDayOrigin,
          PREV_DAY_DESTINATION: vm.model.dayAndEarlyMorningFlightList[i].prevDayDestination,
          PREV_DAY_DEPARTURE: removeSeconds(vm.model.dayAndEarlyMorningFlightList[i].prevDayDepartureDateTime),
          PREV_DAY_ARRIVAL: removeSeconds(vm.model.dayAndEarlyMorningFlightList[i].prevDayArrivalDateTime)
        })
      }
      console.log("dataobject",dataObject);
      return dataObject;
    };

    function removeSeconds(dateTime){
      console.log(dateTime);
      var dateTimeWithoutSec = dateTime.split(":")[0]+":"+dateTime.split(":")[1];
      console.log(dateTimeWithoutSec);
      return dateTimeWithoutSec
    }


    vm.hotSettings = function () {
      var hotSettings = {
        data: dataObject,
        undo: true,
        redo: true,
        copy: true,
        paste: true,
        manualColumnResize: true,
        copyRowsLimit: 1000000,
        // colWidths: [vm.model.width * 0.05, vm.model.width * 0.15, vm.model.width * 0.1, vm.model.width * 0.195, vm.model.width * 0.15, vm.model.width * 0.4, vm.model.width * 0.15],
        colWidths: [1,2,1.5,2,2,2,1,2,3,3,3,3,3,3,3,3,3],
        columns: [
          {
            data: 'ROW_NUMBER',
            type: 'numeric',
            readOnly: true
          },
          {
            data: 'CREW_TYPE_CODE',
            renderer: 'text',
            readOnly: true
          },
          {
            data: 'CREW_ID',
            type: 'text',
            readOnly: true
          },
          {
            data: 'FIRST_NAME',
            type: 'text',
            readOnly: true
          },
          {
            data: 'LAST_NAME',
            type: 'text',
            readOnly: true
          },
          {
            data: 'FLIGHT_NUMBER',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ORIGIN',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DESTINATION',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DEPARTURE_DATE_TIME',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ARRIVAL_DATE_TIME',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DEPARTURE_DATE_TIME_LOCAL',
            type: 'text',
            readOnly: true
          },
          {
            data: 'ARRIVAL_DATE_TIME_LOCAL',
            type: 'text',
            readOnly: true
          },
          {
            data: 'PREV_DAY_FLIGHT_NUMBER',
            type: 'text',
            readOnly: true
          },
          {
            data: 'PREV_DAY_ORIGIN',
            type: 'text',
            readOnly: true
          },
          {
            data: 'PREV_DAY_DESTINATION',
            type: 'text',
            readOnly: true
          },
          {
            data: 'PREV_DAY_DEPARTURE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'PREV_DAY_ARRIVAL',
            type: 'text',
            readOnly: true
          }
          ],

        stretchH: 'all',
        width: vm.model.width * 0.99,
        autoWrapRow: true,
        height: vm.model.height * 0.7,
        rowHeaders: true,
        colHeaders: [
          '',
          'Crew Type',
          'Crew Id',
          'First Name',
          'Last Name',
          'Flight Num',
          'Origin',
          'Destination',
          'Departure Date',
          'Arrival Date',
          'Departure Date(L)',
          'Arrival Date(L)',
          'Prev.Day Flight Num',
          'Prev.Day Origin',
          'Prev.Day Destination',
          'Prev.Day Departure',
          'Prev.Day Arrival'
        ]
      };

      return hotSettings;
    };

    var hotElement = document.querySelector('#hot');


    function setDateValidationFlags() {
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }


    vm.changeSearchField = function (searchParams, flag) {
      setDateValidationFlags();
      if (!vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateFormatInvalid) {
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        } else {
          vm.model.masterList.fromDateAfterToDate = false;

        }
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }

    };


    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    };

    (function () {
      CommonMasterData.getCrewTypeList(function (crewTypeList) {
        vm.model.masterList.crewTypeList = crewTypeList;
      }, function () {
        console.log('Crew Type list retrieval error');
      });

      CommonMasterData.getAircraftModels(function (airCraftList) {
        vm.model.masterList.aircraftTypes = airCraftList;
      }, function () {
        console.log('Aircraft type retrieval error');
      });

    })();

  }
}());
